import {Chip} from '@material-ui/core';
import {DateRange, EmptyDateRange} from 'Core/models/DateRange';
import {FilterOption, FilterOptionValue} from 'Core/models/FilterOption';
import {InequalityRange, isValidInequalityRange, toFormattedInequalityRange} from 'Core/models/InequalityRange';
import * as O from 'fp-ts/lib/Option';
import React from 'react';
import {FilterProperties, FilterType} from 'Shared/components/PagedView/Filter';
import 'Shared/components/PagedView/Table/FilterHeader.sass';
import {toFormattedDate, toFormattedDateRange} from 'Shared/utilities/DateFormatter';
import {toKebabCase} from 'Shared/utilities/stringFormatHelpers';

const FilterChip = (props: {filter: FilterProperties<any>; title: string}) =>
  props.filter.filterType === FilterType.Text || props.filter.filterType === FilterType.RegEx ? (
    <Chip
      id={`filter-header-chip-${toKebabCase(props.title)}`}
      variant="outlined"
      className="filter-header__chip"
      color="primary"
      onDelete={() => props.filter.changeFilter(props.filter.filterKey)('' as any)}
      label={
        <>
          <strong>{props.title}:&nbsp;</strong>
          {props.filter.filterData[props.filter.filterKey] as string}
        </>
      }
    />
  ) : props.filter.filterType === FilterType.Date ? (
    <Chip
      id={`filter-header-chip-${toKebabCase(props.title)}`}
      variant="outlined"
      className="filter-header__chip"
      color="primary"
      onDelete={() => props.filter.changeFilter(props.filter.filterKey)('' as any)}
      label={
        <>
          <strong>{props.title}:&nbsp;</strong>
          {toFormattedDate(props.filter.filterData[props.filter.filterKey] as string)}
        </>
      }
    />
  ) : props.filter.filterType === FilterType.Select ? (
    props.filter.multiple ? (
      <>
        {(props.filter.filterData[props.filter.filterKey] as FilterOption[]).map((fo, index) => (
          <Chip
            id={`filter-header-chip-${toKebabCase(props.title)}`}
            key={`filter-header__chip-${fo.name}`}
            variant="outlined"
            className="filter-header__chip"
            color="primary"
            onDelete={() =>
              props.filter.changeFilter(props.filter.filterKey)(
                (props.filter.filterData[props.filter.filterKey] as FilterOption[]).filter((_, i) => i !== index) as any
              )
            }
            label={
              <>
                <strong>{props.title}:&nbsp;</strong>
                {fo.name}
              </>
            }
          />
        ))}
      </>
    ) : (
      <Chip
        id={`filter-header-chip-${toKebabCase(props.title)}`}
        variant="outlined"
        className="filter-header__chip"
        color="primary"
        onDelete={() => props.filter.changeFilter(props.filter.filterKey)(FilterOptionValue.EmptyOption() as any)}
        label={
          <>
            <strong>{props.title}:&nbsp;</strong>
            {(props.filter.filterData[props.filter.filterKey] as FilterOption).name}
          </>
        }
      />
    )
  ) : props.filter.filterType === FilterType.Inequality ? (
    <Chip
      id={`filter-header-chip-${toKebabCase(props.title)}`}
      variant="outlined"
      className="filter-header__chip"
      color="primary"
      onDelete={() => props.filter.changeFilter(props.filter.filterKey)(O.none as any)}
      label={
        <>
          <strong>{props.title}:&nbsp;</strong>
          {toFormattedInequalityRange(
            (isValidInequalityRange(props.filter.filterData[props.filter.filterKey].value)
              ? props.filter.filterData[props.filter.filterKey].value
              : '') as InequalityRange
          )}
        </>
      }
    />
  ) : (
    <Chip
      id={`filter-header-chip-${toKebabCase(props.title)}`}
      variant="outlined"
      className="filter-header__chip"
      color="primary"
      onDelete={() => props.filter.changeFilter(props.filter.filterKey)(EmptyDateRange as any)}
      label={
        <>
          <strong>{props.title}:&nbsp;</strong>
          {toFormattedDateRange(props.filter.filterData[props.filter.filterKey] as DateRange)}
        </>
      }
    />
  );

export default FilterChip;
